import { Trans } from 'react-i18next';
export const introCards = [
  {
    title: (
      <Trans
        i18nKey="business:ReducePage.intro.cards.card1.title"
        components={{
          1: <br />,
        }}
      />
    ),
    body: [
      // @i18n: It is a way of standardizing the intensity of your operational carbon emissions per[...]
      <Trans i18nKey="business:ReducePage.intro.cards.card1.para1" />,
      // @i18n: This means that it can adjust with your business as you grow and expand your operations.
      <Trans i18nKey="business:ReducePage.intro.cards.card1.para2" />,
    ],
  },
  {
    title: (
      <Trans
        i18nKey="business:ReducePage.intro.cards.card2.title"
        components={{
          1: <br />,
        }}
      />
    ),
    body: [
      // @i18n: Your total carbon emissions are divided by the value you entered for your chosen[...]
      <Trans i18nKey="business:ReducePage.intro.cards.card2.para1" />,
      // @i18n: This gives an estimated carbon intensity, expressed as tCO₂e per unit.
      <Trans i18nKey="business:ReducePage.intro.cards.card2.para2" />,
    ],
  },
  {
    title: (
      <Trans
        i18nKey="business:ReducePage.intro.cards.card3.title"
        components={{
          1: <br />,
        }}
      />
    ),
    body: [
      // @i18n: Your carbon intensity will usually be displayed as a decimal number.
      <Trans i18nKey="business:ReducePage.intro.cards.card3.para1" />,
      // @i18n: The closer it is to 0, the more you’re reducing your emissions.
      <Trans i18nKey="business:ReducePage.intro.cards.card3.para2" />,
    ],
  },
  {
    title: (
      // @i18n: What does 'baseline carbon intensity' mean?
      <Trans i18nKey="business:ReducePage.intro.cards.card4.title" />
    ),
    body: [
      // @i18n: It is a record of the carbon intensity calculated during your airport's first carbon[...]
      <Trans i18nKey="business:ReducePage.intro.cards.card4.para1" />,
    ],
  },
];
export const infoCardsV3 = [
  {
    key: 'baseline-carbon-intensity',
    // @i18n: Baseline carbon intensity
    title: <Trans i18nKey="business:ReducePageV3.targetsPage.tips.tip1.title" />,
    // @i18n: This is the total calculated carbon emissions based on the data entered in your first[...]
    body: <Trans i18nKey="business:ReducePageV3.targetsPage.tips.tip1.para" />,
  },
  {
    key: 'reduction-targets',
    // @i18n: Reduction targets
    title: <Trans i18nKey="business:ReducePageV3.targetsPage.tips.tip2.title" />,
    // @i18n: These are the targets your business is aiming to meet over your next and future[...]
    body: <Trans i18nKey="business:ReducePageV3.targetsPage.tips.tip2.para" />,
  },
];
export const reductionCardsV3 = [
  {
    key: 'next-reporting-period',
    title: <Trans i18nKey="business:ReducePageV3.targetsPage.projections.cards.card1.title" />,
    body: [
      <Trans i18nKey="business:ReducePageV3.targetsPage.projections.cards.card1.para1" />,
      <Trans i18nKey="business:ReducePageV3.targetsPage.projections.cards.card1.para2" />,
    ],
  },
  {
    key: 'next-period-dates',
    title: <Trans i18nKey="business:ReducePageV3.targetsPage.projections.cards.card2.title" />,
    body: [
      <Trans i18nKey="business:ReducePageV3.targetsPage.projections.cards.card2.para1" />,
      <Trans i18nKey="business:ReducePageV3.targetsPage.projections.cards.card2.para2" />,
    ],
    hasNextReductionPeriod: true,
  },
  {
    key: 'future-reporting-periods',
    title: <Trans i18nKey="business:ReducePageV3.targetsPage.projections.cards.card3.title" />,
    body: [
      <Trans i18nKey="business:ReducePageV3.targetsPage.projections.cards.card3.para1" />,
      <Trans i18nKey="business:ReducePageV3.targetsPage.projections.cards.card3.para2" />,
    ],
  },
];
export const reductionInstructions = [
  'business:ReducePage.reductions.reducePlan.tip1',
  'business:ReducePage.reductions.reducePlan.tip2',
];
export const reductionCardsSlides = {
  companyVehicles: ['slide1', 'slide2', 'slide3', 'slide4'],
  onSiteWaterTreatment: ['slide1', 'slide2', 'slide3', 'slide4'],
  onSitePowerGeneration: ['slide1'],
  fireFightingExercises: ['slide1'],
  boilersAndFurnances: ['slide1'],
  refrigerants: ['slide1'],
  electricity: ['slide1', 'slide2', 'slide3'],
  employeeCommutes: ['slide1', 'slide2', 'slide3', 'slide4', 'slide5'],
  businessTravel: ['slide1', 'slide2', 'slide3'],
  evCharging: ['slide1', 'slide2', 'slide3'],
};
export const barGraphLayoutIsVerticallyScalable = true;
